import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import AREAS from "@/data/practiceAreas";

const PRACTICE_IMAGE = "https://images.unsplash.com/photo-1589829545856-d10d557cf95f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwxfHxnYXZlbCUyMGp1c3RpY2UlMjBsZWdhbHxlbnwwfHx8fDE3ODEyNDg2Mzl8MA&ixlib=rb-4.1.0&q=85";

export default function Practice() {
  return (
    <section
      id="practice"
      data-testid="practice-section"
      className="section"
      style={{ backgroundColor: "#FFFFFF", borderTop: "1px solid #E2DCD0", borderBottom: "1px solid #E2DCD0" }}
    >
      <div className="container-x">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-20 items-end">
          <div className="md:col-span-7">
            <span className="ornament text-xs" style={{ letterSpacing: "0.28em", textTransform: "uppercase" }}>
              Areas of Practice
            </span>
            <h2 className="font-serif-display mt-6 text-4xl md:text-5xl" style={{ color: "#0A1128", fontWeight: 500, lineHeight: 1.1 }}>
              Eight disciplines.
              <br />
              <span style={{ fontStyle: "italic", color: "#7A2021" }}>One standard of work.</span>
            </h2>
          </div>
          <div className="md:col-span-5">
            <p className="text-base md:text-lg" style={{ color: "#334155", lineHeight: 1.7 }}>
              We accept a measured volume of briefs each year so that every matter receives
              personal attention from the advocate on record.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px" style={{ backgroundColor: "#E2DCD0", border: "1px solid #E2DCD0" }}>
          {AREAS.map((a) => (
            <PracticeCard key={a.slug} area={a} />
          ))}
          <div
            className="hidden lg:flex flex-col justify-between p-8"
            style={{ backgroundColor: "#0A1128", color: "#F9F6F0" }}
            data-testid="practice-card-image"
          >
            <span className="text-[10px] uppercase" style={{ color: "#C5A059", letterSpacing: "0.28em" }}>
              Indicative
            </span>
            <img
              src={PRACTICE_IMAGE}
              alt="A wooden judge's gavel resting on a legal desk — Sikdar & Sikdar, Advocates"
              className="w-full h-40 object-cover my-6"
              loading="lazy"
            />
            <p className="font-serif-display text-xl leading-snug" style={{ fontStyle: "italic" }}>
              &ldquo;Audi alteram partem — let the other side be heard.&rdquo;
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

function PracticeCard({ area }) {
  const Icon = area.icon;
  return (
    <Link
      to={`/practice/${area.slug}`}
      className="group p-8 transition-colors flex flex-col gap-5"
      style={{ backgroundColor: "#FFFFFF" }}
      data-testid={`practice-card-${area.slug}`}
    >
      <div className="flex items-center justify-between">
        <Icon size={28} strokeWidth={1.4} style={{ color: "#7A2021" }} />
        <ArrowUpRight
          size={18}
          strokeWidth={1.5}
          style={{ color: "#C5A059" }}
          className="opacity-0 group-hover:opacity-100 transition-opacity"
        />
      </div>
      <h3 className="font-serif-display text-2xl md:text-3xl" style={{ color: "#0A1128", fontWeight: 500 }}>
        {area.short}
      </h3>
      <p className="text-sm md:text-base" style={{ color: "#334155", lineHeight: 1.65 }}>{area.blurb}</p>
      <ul className="mt-2 space-y-1.5">
        {area.matters.map((m) => (
          <li key={m} className="flex items-center gap-2 text-xs uppercase" style={{ color: "#64748B", letterSpacing: "0.14em" }}>
            <span className="inline-block w-3 h-px" style={{ backgroundColor: "#C5A059" }} />
            {m}
          </li>
        ))}
      </ul>
      <span
        className="mt-auto pt-4 text-[11px] uppercase inline-flex items-center gap-1"
        style={{ color: "#7A2021", letterSpacing: "0.2em" }}
      >
        Read more <ArrowUpRight size={12} strokeWidth={2} />
      </span>
    </Link>
  );
}
